import React from 'react';

/**
 * Highlights @N patterns (e.g. @1, @2, @12) in prompt text
 * by wrapping them in styled <span> elements.
 */
export function highlightAtRefs(text: string): React.ReactNode {
  const parts = text.split(/(@(?:图片|视频|音频)\d+|@\d+)/g);
  if (parts.length === 1) return text;

  return parts.map((part, i) =>
    /^(?:@(?:图片|视频|音频)\d+|@\d+)$/.test(part) ? (
      <span
        key={i}
        style={{
          color: 'var(--theme-storyboard)',
          background: 'rgba(6, 182, 212, 0.1)',
          borderRadius: '2px',
          padding: '0 3px',
          fontWeight: 600,
        }}
      >
        {part}
      </span>
    ) : (
      part
    )
  );
}
